import { render, staticRenderFns } from "./NotFoundScreen.vue?vue&type=template&id=100de824&scoped=true&lang=pug"
import script from "./NotFoundScreen.vue?vue&type=script&lang=ts"
export * from "./NotFoundScreen.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundScreen.vue?vue&type=style&index=0&id=100de824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100de824",
  null
  
)

export default component.exports